import axios from 'axios'

export const state = {
  SurveyQuestions: []
}
export const getters = {
  surveyQuestions: (state) => {
    return state.SurveyQuestions
  },
  surveyQuestionById: (state) => (surveyQuestionId) => {
    return state.SurveyQuestions.find(surveyQuestion => surveyQuestion.id === surveyQuestionId)
  },
  surveyQuestionsByIds: (state) => (surveyQuestionIds) => {
    return state.SurveyQuestions.filter(surveyQuestion => surveyQuestionIds.indexOf(surveyQuestion.id) > -1)
  }
}

export const mutations = {
  surveyQuestions (state, surveyQuestions) {
    state.SurveyQuestions = surveyQuestions
  },
  surveyQuestionPatch (state, surveyQuestion) {
    const index = state.SurveyQuestions.findIndex(item => item.id === surveyQuestion.id)
    if (index > -1) {
      state.SurveyQuestions.splice(index, 1, surveyQuestion)
    } else {
      state.SurveyQuestions.push(surveyQuestion)
    }
  },
  surveyQuestionDelete (state, surveyQuestionId) {
    const index = state.SurveyQuestions.findIndex(item => item.id === surveyQuestionId)
    if (index > -1) {
      state.SurveyQuestions.splice(index, 1)
    }
  }
}

export const actions = {
  async surveyQuestionById (store, surveyQuestionId) {
    const { data } = await axios.get('/api/survey-questions/' + surveyQuestionId)
    store.commit('surveyQuestionPatch', data)
    return data
  },
  async surveyQuestions (store, params = {}) {
    if (!params.page) {
      params.page = 1
    }
    const { data } = await axios.get('/api/survey-questions', { params: params })

    store.commit('surveyQuestions', data.data)
    return data
  },
  async surveyQuestionDelete (store, surveyQuestionId) {
    await axios.delete('/api/survey-questions/' + surveyQuestionId)
    store.commit('surveyQuestionDelete', surveyQuestionId)
  },
  async surveyQuestionPatch (store, payload = {}) {
    const { data } = await axios.patch('/api/survey-questions/' + payload.id, payload)
    store.commit('surveyQuestionPatch', data)
    return data
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
